import { Controller } from 'react-hook-form';
import { FormControlLabel, FormLabel, Radio, RadioGroup, Typography } from '@customink/pigment-react';
import { AddressDialogFieldProps } from '../../types';

export const AddressType = ({ control }: AddressDialogFieldProps) => (
    <>
        <FormLabel id="address-type-radio">
            <Typography>Address Type</Typography>{' '}
            <Typography sx={(theme) => ({ color: theme.palette.text.secondary })}>(Helps with delivery)</Typography>
        </FormLabel>
        <Controller
            name="addressType"
            control={control}
            render={({ field }) => (
                // eslint-disable-next-line react/jsx-props-no-spreading
                <RadioGroup {...field} aria-labelledby="address-type-radio" style={{ flexDirection: 'row' }}>
                    <FormControlLabel control={<Radio />} label="residential" value="residential" />
                    <FormControlLabel control={<Radio />} label="business" value="business" />
                </RadioGroup>
            )}
        />
    </>
);
